// extracted by mini-css-extract-plugin
export default {"button":"redButton_button__HlHqg"};